import React from "react";
import FlagIconFactory from "react-flag-icon-css";

export const Flag = FlagIconFactory(React, { useCssModules: false });
